var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$store.state.auth)?_c('NavegationMenu',{on:{"menu":_vm.changeMenu}}):_vm._e(),_c('v-main',{staticClass:"light"},[_c('router-view',{attrs:{"reportMenuPass":_vm.itemMenu,"menuSelectMobile":_vm.menu}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }